import { useEffect, useRef } from 'react';
import Text from '../../Style-guide/Text';
import AvailableHoursWrapper from './style/availableHoursWrapper';

const AvailableHours = (props) => {
  const { selectedSlot, setSelectedSlot, availability, setShowModal } = props;
  const wrapperRef = useRef(null);

  /// handle selecting a slot with single endTime
  const handleSlotClick = (slot) => {
    if (slot.end.length === 1) {
      setSelectedSlot({ start: slot.start, end: slot.end[0] });
      setShowModal(true);
    } else {
      setSelectedSlot({ start: slot.start, end: null });
    }
  };

  /// handle selecting a slot with multiple endTimes
  const handleMultipleEndTimeClick = (event, endTime) => {
    event.stopPropagation();
    setSelectedSlot({ ...selectedSlot, end: endTime });
    setShowModal(true);
  };

  /// handle unselecting the slot when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setSelectedSlot({ start: null, end: null });
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setSelectedSlot]);

  const displaySelectedSlot = (slot) => {
    if (slot.end.length === 1) {
      return (
        <Text className='hours-list-item-text single-option' size='MD'>
          {slot.start} - {slot.end[0]}
        </Text>
      );
    }

    if (slot.end.length > 1 && selectedSlot?.start !== slot.start) {
      return (
        <Text className='hours-list-item-text' size='MD'>
          {slot.start}
        </Text>
      );
    }

    if (slot.end.length > 1 && selectedSlot?.start === slot.start) {
      return slot.end.map((endTime, endIndex) => (
        <Text
          onClick={(e) => handleMultipleEndTimeClick(e, endTime)}
          className='hours-list-item-text '
          size='MD'
          key={endIndex}
        >
          {endTime}
        </Text>
      ));
    }
  };

  return (
    <AvailableHoursWrapper ref={wrapperRef} className='time-section section'>
      {availability ? (
        <ul className='hours-list'>
          {availability.map((slot, index) => (
            <li
              className={`hours-list-item  ${selectedSlot.start === slot.start ? 'selected-item' : ''}`}
              key={index}
              onClick={() => handleSlotClick(slot)}
            >
              {displaySelectedSlot(slot)}
            </li>
          ))}
        </ul>
      ) : null}
    </AvailableHoursWrapper>
  );
};

export default AvailableHours;
